<template>
    <!-- 增/改煤矿页面 -->
    <el-form :model="AddData" :rules="rules" ref="AddData" size="small" label-width="180px" label-position="top">
        <!-- 头部开始 -->
        <el-row class="pur-top">
        <el-col :span="3">
            <el-button type="text" icon="el-icon-s-home">{{ ruData.type }}{{ ruData.purTitle }}<span v-if="ruData.type === '编辑'">/{{ AddData.city }} - {{ AddData.area }}</span>
            </el-button>
        </el-col>
        <el-col :span="21" class="pur-right">
            <el-button type="primary" v-if="ruData.type === '新增'" size="small" @click="AddDatasubmitForm('AddData')" :loading="loading">保 存</el-button>
            <el-button type="primary" v-if="ruData.type === '编辑'" size="small" @click="EditDatasubmitForm('AddData')" :loading="loading">保 存</el-button>
            <el-button size="small" style="margin-left: 24px"  @click="Addopen">取 消</el-button>
        </el-col>
        </el-row>
        <!-- 头部结束 -->
        <!-- 内容开始 -->
        <div class="pur-nav">
            <!-- 表单 -->
            <div class="pur-table" v-loading="loading"
            element-loading-text="保存数据中，请耐心等待...">
                <el-row :gutter="20">
                    <!-- 基础信息 -->
                    <el-col :span="24">
                        <div class="see-top"><div></div>基础信息</div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="地区(市)/县城" prop="cityValue">
                            <el-cascader
                                :disabled="ruData.type === '编辑'?true:false"
                                v-model="AddData.cityValue"
                                :options="options"
                                :props="{ label: 'label', value: 'value', children: 'children' }"
                                @change="handleChange"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="矿井状态">
                            <el-input v-model="AddData.mineStatus"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="安全等级">
                            <el-input v-model="AddData.securityLevel"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="煤矿简称">
                            <el-input v-model="AddData.simpleName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="煤矿全称">
                            <el-input v-model="AddData.coalFullName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="所属集团">
                            <el-input v-model="AddData.membershipGroup"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="矿井性质">
                            <el-input v-model="AddData.mineNature"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="产能(万吨)">
                            <el-input v-model="AddData.capacity"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="是否有量价优惠">
                            <el-input v-model="AddData.hasPriceDiscount"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="地区客服驿站">
                            <el-input v-model="AddData.serviceStation"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="煤矿地址">
                            <el-input v-model="AddData.coalMineAddress"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="坑口洗煤厂名称">
                            <el-input v-model="AddData.washingName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="驿站联系人">
                            <el-input v-model="AddData.stationContactPerson"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="驿站联系方式">
                            <el-input v-model="AddData.stationContactInformation"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="矿点联系人">
                            <el-input v-model="AddData.mineContactPerson"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="矿点联系电话">
                            <el-input v-model="AddData.mineContactPhoneNumber"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="原煤/精煤">
                            <el-input v-model="AddData.coalType"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="挂单仓号">
                            <el-input v-model="AddData.warehouseNb"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="竞拍情况">
                            <el-input v-model="AddData.auctionSituation"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="竞拍平台">
                            <el-input v-model="AddData.auctionPlatform"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="所产煤种">
                            <el-input v-model="AddData.coalTypesProduced"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="出厂含税价">
                            <el-input v-model="AddData.factoryTaxPrice"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="硫(St,d)%">
                            <el-input v-model="AddData.sulfur"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="灰份(Ad）%">
                            <el-input v-model="AddData.ashContent"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="水份(Mt)%">
                            <el-input v-model="AddData.water"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="挥发份(Vdaf)%" >
                            <el-input v-model="AddData.evaporate"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="粘结指数（GR.I）" label-width="160px">
                            <el-input v-model="AddData.bond"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="YMM">
                            <el-input v-model="AddData.ymm"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="热态（CSR）">
                            <el-input v-model="AddData.csr"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="岩相(S)">
                            <el-input v-model="AddData.strength"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="发热量(Q)">
                            <el-input v-model="AddData.calorificValue"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="备注">
                            <el-input v-model="AddData.remark"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 内容结束 -->
    </el-form>
</template>
<script>
import citycode from "../citycode.js";

export default {
    data() {
        return {
            options:citycode,
            loading:false,
            // 表单验证
            rules: {
                // 地区
                cityValue: [
                    { required: true, message: '请选择地区', trigger: 'change' }
                ],
                // 矿井状态
                mineStatus: [
                    { required: true, message: '请输入矿井状态', trigger: 'blur' },
                    { max: 20, message: '最多输入20个字符', trigger: 'blur' }
                ],
                // 安全等级
                securityLevel: [
                    { max: 1, message: '只能输入一个字母（A/B/C/D）', trigger: 'blur' },
                    { pattern: /^[ABCD]$/, message: '请输入 A、B、C 或 D', trigger: 'blur' }
                ],
                // 煤矿全称
                coalFullName: [
                    { required: true, message: '请输入煤矿全称', trigger: 'blur' },
                    { max: 20, message: '最多输入20个字符', trigger: 'blur' }
                ],
                // 简称
                simpleName: [
                    { max: 20, message: '最多输入20个字符', trigger: 'blur' }
                ],
                // 所属集团
                membershipGroup: [
                    { required: true, message: '请输入所属集团名称', trigger: 'blur' },
                    { max: 20, message: '最多输入20个字符', trigger: 'blur' }
                ],
                // 矿井性质
                mineNature: [
                    { required: true, message: '请输入矿井性质', trigger: 'blur' }
                ],
                // 产能
                capacity: [
                    { validator: (rule, value, callback) => {
                        if (value && isNaN(Number(value))) {
                        callback(new Error('请输入数字'));
                        } else {
                        callback();
                        }
                    }, trigger: 'blur'
                    }
                ],
                // 煤矿地址
                coalMineAddress: [
                    { max: 30, message: '最多输入30个字符', trigger: 'blur' }
                ],
                // 是否有量价优惠
                hasPriceDiscount: [
                    { validator: (rule, value, callback) => {
                        const validValues = ['是', '否'];
                        if (value && !validValues.includes(value)) {
                        callback(new Error('请输入“是”或“否”'));
                        } else {
                        callback();
                        }
                    }, trigger: 'blur'
                    }
                ],
                // 地区客服驿站
                serviceStation: [
                    { max: 20, message: '最多输入20个字符', trigger: 'blur' }
                ],
                // 驿站联系人
                stationContactPerson: [],
                // 驿站联系方式
                stationContactInformation: [
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
                ],
                // 矿点联系人
                mineContactPerson: [],
                // 矿点联系电话
                mineContactPhoneNumber: [
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }
                ],
                // 原煤/精煤
                coalType: [],
                // 坑口洗煤厂名称
                washingName: [
                    { max: 20, message: '最多输入20个字符', trigger: 'blur' }
                ],
                // 挂单仓号
                warehouseNb: [],
                // 竞拍情况
                auctionSituation: [],
                // 竞拍平台
                auctionPlatform: [],
                // 所产煤种
                coalTypesProduced: [
                    { required: true, message: '请输入所产煤种', trigger: 'blur' }
                ],
                // 硫(St,d)%
                sulfur: [
                    { required: true, message: '请输入硫含量', trigger: 'blur' },
                ],
                // 挥发份(Vdaf)%
                evaporate: [
                    { required: true, message: '请输入挥发份', trigger: 'blur' },
                ],
                // 灰份(Ad）
                ashContent: [
                    { required: true, message: '请输入灰份', trigger: 'blur' },
                ],
                // 粘结指数（GR.I）
                bond: [
                    { required: true, message: '请输入粘结指数', trigger: 'blur' },
                ],
                // YMM
                ymm: [
                    { max: 10, message: '最多输入10个字符', trigger: 'blur' }
                ],
                // 强度（CSR）
                csr: [
                    { max: 10, message: '最多输入10个字符', trigger: 'blur' }
                ],
                // 岩相(S)
                strength: [
                    { max: 10, message: '最多输入10个字符', trigger: 'blur' }
                ],
                // 发热量(Q)
                calorificValue: [
                    { max: 10, message: '最多输入10个字符', trigger: 'blur' }
                ],
                // 出厂含税价
                factoryTaxPrice: [
                    { required: true, message: '请输入出厂含税价格', trigger: 'blur' },
                    { validator: (rule, value, callback) => {
                        if (value && isNaN(Number(value))) {
                        callback(new Error('请输入数字'));
                        } else {
                        callback();
                        }
                    }, trigger: 'blur'
                    }
                ],
                // 备注
                remark: []
            },
            // 表单数据
            AddData :{
                cityValue: "",
                mineStatus: "",
                securityLevel: "",
                coalFullName: "",
                simpleName: "",
                membershipGroup: "",
                mineNature: "",
                capacity: "",
                coalMineAddress: "",
                hasPriceDiscount: "",
                serviceStation: "",
                stationContactPerson: "",
                stationContactInformation: "",
                mineContactPerson: "",
                mineContactPhoneNumber: "",
                coalType: "",
                washingName: "",
                warehouseNb: "",
                auctionSituation: "",
                auctionPlatform: "",
                coalTypesProduced: "",
                sulfur: "",
                evaporate: "",
                ashContent: "",
                water: "",
                bond: "",
                ymm: "",
                csr: "",
                strength: "",
                calorificValue: "",
                factoryTaxPrice: "",
                remark: ""
            },
            ruData:{},
        };
    },
    created() {
        
    },
    mounted () {
        // 获取路由参数
        this.ruData = this.$route.query;
        this.ruData.type === '编辑'?this.getbeyid(this.ruData.id):'';
    },
    methods: {
        getbeyid(id){
            this.api.xmmcCoal.one({id:id})
            .then(res=>{
                if(res.data.code == 200){
                    const data = res.data.data;
                    let arr = [];
                    arr.push(data.city);
                    arr.push(data.area);
                     // 将 ["山西省", "太原市"] 转为 ["140000", "140100"]
                    const selectedValue = this.findValueByLabel(this.options, arr);
                    this.$set(this.AddData, 'cityValue', selectedValue); // 回显
                    Object.assign(this.AddData, data); // 其他字段赋值
                }
            })
        },
        // 工具方法：根据 label 查找 value
        findValueByLabel(options, labels, level = 0) {
            if (!labels || !labels[level]) return '';
            const matched = options.find(item => item.label === labels[level]);
            if (!matched) return '';
            if (level === labels.length - 1) {
                return matched.value;
            } else if (matched.children && matched.children.length > 0) {
                return [matched.value].concat(this.findValueByLabel(matched.children, labels, level + 1));
            } else {
                return matched.value;
            }
        },
        // 地区-县城
        handleChange(value) {
            // 将 ['140000', '140100'] 转为 ['山西省', '太原市']
            const labels = this.findLabelByValue(this.options, value);
            this.AddData.cityCode = value[0];        // 市/地区code
            this.AddData.areaCode = value[1];        // 区县/县城code
            this.AddData.city = labels[0];        // 省/市中文名
            this.AddData.area = labels[1];        // 区县中文名
        },
        // 根据地区-县城 value 查找 label 的递归函数
        findLabelByValue(options, values, level = 0) {
            if (!values || !values[level]) return '';
                const matched = options.find(item => item.value === values[level]);
            if (!matched) return '';
            if (level === values.length - 1) {
                return matched.label;
            } else if (matched.children && matched.children.length > 0) {
                return [matched.label].concat(this.findLabelByValue(matched.children, values, level + 1));
            } else {
                return matched.label;
            }
        },
        // 编辑表单提交
        EditDatasubmitForm(formName) {
            this.$refs[formName].clearValidate();
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.api.xmmcCoal.edit(this.AddData)
                    .then(res=>{
                        var that = this;
                        if(res.data.code == 200){
                            that.$message({
                                type: "success",
                                message: "编辑成功!",
                                duration:500,  
                                onClose(){
                                    that.$router.push({
                                        name:"collierys",
                                        query: {
                                            activeTab: that.AddData.city,
                                        }
                                    })
                                }
                            });
                            that.loading = false;
                        }
                    })
                }
            });
        },
        // 新增表单提交
        AddDatasubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.api.xmmcCoal.add(this.AddData)
                    .then(res=>{
                        if(res.data.code == 200){
                            var that = this
                            that.$message({
                                type: "success",
                                message: "新增成功!",
                                duration:500,  
                                onClose(){
                                    that.$router.push({
                                        name:"collierys",
                                        query: {
                                            activeTab: that.AddData.city,
                                        }
                                    })
                                }
                            });
                            that.loading = false;
                        }
                    })
                }
            });
        },
        // 取消保存表单
        Addopen() {
            this.loading = false;
            this.$router.push({name:"collierys",query: {activeTab: this.AddData.city}});
        },
    },
    computed: {},
    watch: {}
};
</script>
<style lang="less" scoped>
.separated-input-container {
    display: flex;
    align-items: center;
}
// 头部开始
.pur-top {
    width: 100%;
    height: 50px;
    padding: 9px 24px 9px 32px;
    background-color: #fff;
    box-sizing: border-box;
    box-shadow: 2px 2px 10px rgba(102, 102, 102, 0.15);
    .pur-right {
        .el-button {
            margin-left: 16px;
            float: right;
        }
    }
}
// 头部结束
// 表单内容开始
.pur-nav {
    height: calc(100vh - 110px);
    background-color: #fff;
    margin: 0 60px;
    box-shadow: 2px 2px 10px rgba(102, 102, 102, 0.15);
    padding:32px 18px 32px 32px;
    box-sizing: border-box;
    .pur-table {
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        .see-top {
            height: 40px;
            font-weight: 600;
            font-size: 14px;
            line-height: 45px;
            margin-bottom:24px;
            div{
                width: 2px;
                height:15px;
                margin:15px 6px 0 0;
                background-color: #EA222E;
                float: left;
            }
        }
    }
}
// 表单内容结束
</style>